import { useAppSelector } from "../store.hook";
import { PotentialMatrixFilters } from "../usePotentialMatrixFilters.hook";

export const usePracticeCompetenceData = (
  filters: Pick<PotentialMatrixFilters, "practice">,
) => {
  const { orgSettings } = useAppSelector((state) => state.config);

  const practiceList = orgSettings.areaList.filtered.map(
    (item) => item.practiceList,
  )[0];

  const CCList = practiceList
    ? practiceList
        .filter((item) => filters.practice?.includes(item.id))
        .flatMap((item) => item.ccList)
    : [];

  return { practiceList, CCList };
};
